export const ADVANCED_DETAILS_APIS = {
  get_payment_modes: "payments/exly/transaction/modes",
};
